
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Checkout() {
  const [step, setStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [shippingMethod, setShippingMethod] = useState('standard');

  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    postalCode: '',
    cardNumber: '',
    cardName: '',
    expiryDate: '',
    cvv: ''
  });

  const orderItems = [
    { name: 'طماطم طازجة - كيلو', quantity: 2, price: 12 },
    { name: 'حليب طازج - لتر', quantity: 1, price: 15 },
    { name: 'خبز طازج', quantity: 1, price: 8 }
  ];

  const subtotal = 47;
  const shipping = shippingMethod === 'express' ? 15 : 10;
  const total = subtotal + shipping;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    // سيتم ربطه مع Stripe لاحقاً
    alert('سيتم ربط الدفع مع Stripe قريباً!');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-32" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/cart" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h2 className="text-lg font-bold text-gray-800">إتمام الطلب</h2>
          <div className="w-10"></div>
        </div>

        {/* Progress Steps */}
        <div className="px-4 pb-3">
          <div className="flex items-center justify-between">
            <div className="flex flex-col items-center flex-1">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                step >= 1 ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white' : 'bg-gray-200 text-gray-400'
              }`}>
                {step > 1 ? <i className="ri-check-line text-xl"></i> : '1'}
              </div>
              <span className="text-xs mt-1 text-gray-600">العنوان</span>
            </div>
            <div className={`flex-1 h-1 mx-2 rounded transition-all duration-300 ${
              step >= 2 ? 'bg-gradient-to-r from-blue-500 to-purple-500' : 'bg-gray-200'
            }`}></div>
            <div className="flex flex-col items-center flex-1">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                step >= 2 ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white' : 'bg-gray-200 text-gray-400'
              }`}>
                {step > 2 ? <i className="ri-check-line text-xl"></i> : '2'}
              </div>
              <span className="text-xs mt-1 text-gray-600">الشحن</span>
            </div>
            <div className={`flex-1 h-1 mx-2 rounded transition-all duration-300 ${
              step >= 3 ? 'bg-gradient-to-r from-blue-500 to-purple-500' : 'bg-gray-200'
            }`}></div>
            <div className="flex flex-col items-center flex-1">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                step >= 3 ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white' : 'bg-gray-200 text-gray-400'
              }`}>
                3
              </div>
              <span className="text-xs mt-1 text-gray-600">الدفع</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-36 px-4">
        {/* Step 1: Shipping Address */}
        {step === 1 && (
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">معلومات الشحن</h3>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="الاسم الكامل"
              className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="رقم الجوال"
              className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="البريد الإلكتروني"
              className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="العنوان بالتفصيل"
              className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                placeholder="المدينة"
                className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleInputChange}
                placeholder="الرمز البريدي"
                className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        )}

        {/* Step 2: Shipping Method */}
        {step === 2 && (
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">طريقة الشحن</h3>
            <button
              onClick={() => setShippingMethod('standard')}
              className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 ${
                shippingMethod === 'standard'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    shippingMethod === 'standard' ? 'border-blue-500' : 'border-gray-300'
                  }`}>
                    {shippingMethod === 'standard' && (
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    )}
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-gray-800">شحن عادي</p>
                    <p className="text-sm text-gray-600">التوصيل خلال 3-5 أيام</p>
                  </div>
                </div>
                <span className="font-bold text-gray-800">10 ر.س</span>
              </div>
            </button>
            <button
              onClick={() => setShippingMethod('express')}
              className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 ${
                shippingMethod === 'express'
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    shippingMethod === 'express' ? 'border-blue-500' : 'border-gray-300'
                  }`}>
                    {shippingMethod === 'express' && (
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    )}
                  </div>
                  <div className="text-right">
                    <p className="font-bold text-gray-800">شحن سريع</p>
                    <p className="text-sm text-gray-600">التوصيل خلال 1-2 يوم</p>
                  </div>
                </div>
                <span className="font-bold text-gray-800">15 ر.س</span>
              </div>
            </button>
          </div>
        )}

        {/* Step 3: Payment */}
        {step === 3 && (
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">طريقة الدفع</h3>
            
            {/* Payment Methods */}
            <div className="space-y-3 mb-6">
              <button
                onClick={() => setPaymentMethod('card')}
                className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 ${
                  paymentMethod === 'card'
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 bg-white'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    paymentMethod === 'card' ? 'border-blue-500' : 'border-gray-300'
                  }`}>
                    {paymentMethod === 'card' && (
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    )}
                  </div>
                  <i className="ri-bank-card-line text-2xl text-gray-700"></i>
                  <span className="font-bold text-gray-800">بطاقة ائتمان</span>
                </div>
              </button>
              <button
                onClick={() => setPaymentMethod('cash')}
                className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 ${
                  paymentMethod === 'cash'
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 bg-white'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                    paymentMethod === 'cash' ? 'border-blue-500' : 'border-gray-300'
                  }`}>
                    {paymentMethod === 'cash' && (
                      <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    )}
                  </div>
                  <i className="ri-money-dollar-circle-line text-2xl text-gray-700"></i>
                  <span className="font-bold text-gray-800">الدفع عند الاستلام</span>
                </div>
              </button>
            </div>

            {/* Card Details */}
            {paymentMethod === 'card' && (
              <div className="space-y-4">
                <input
                  type="text"
                  name="cardNumber"
                  value={formData.cardNumber}
                  onChange={handleInputChange}
                  placeholder="رقم البطاقة"
                  maxLength={16}
                  className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  name="cardName"
                  value={formData.cardName}
                  onChange={handleInputChange}
                  placeholder="اسم حامل البطاقة"
                  className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <div className="grid grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="expiryDate"
                    value={formData.expiryDate}
                    onChange={handleInputChange}
                    placeholder="MM/YY"
                    maxLength={5}
                    className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="cvv"
                    value={formData.cvv}
                    onChange={handleInputChange}
                    placeholder="CVV"
                    maxLength={3}
                    className="w-full px-4 py-3 bg-white rounded-xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {/* Order Summary */}
        <div className="bg-white rounded-2xl p-6 shadow-sm mt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">ملخص الطلب</h3>
          <div className="space-y-2 mb-4">
            {orderItems.map((item, index) => (
              <div key={index} className="flex items-center justify-between text-sm text-gray-600">
                <span>{item.name} × {item.quantity}</span>
                <span className="font-bold">{item.price * item.quantity} ر.س</span>
              </div>
            ))}
          </div>
          <div className="border-t border-gray-200 pt-3 space-y-2">
            <div className="flex items-center justify-between text-gray-600">
              <span>المجموع الفرعي</span>
              <span className="font-bold">{subtotal} ر.س</span>
            </div>
            <div className="flex items-center justify-between text-gray-600">
              <span>الشحن</span>
              <span className="font-bold">{shipping} ر.س</span>
            </div>
            <div className="border-t border-gray-200 pt-2 flex items-center justify-between">
              <span className="text-lg font-bold text-gray-800">المجموع الكلي</span>
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                {total} ر.س
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 px-4 py-4 z-50">
        <div className="flex gap-3">
          {step > 1 && (
            <button
              onClick={() => setStep(step - 1)}
              className="px-6 py-4 bg-gray-100 text-gray-700 rounded-2xl font-bold hover:bg-gray-200 transition-colors"
            >
              السابق
            </button>
          )}
          <button
            onClick={() => step === 3 ? handleSubmit() : setStep(step + 1)}
            className="flex-1 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            {step === 3 ? 'تأكيد الطلب' : 'التالي'}
          </button>
        </div>
      </div>
    </div>
  );
}
